import styles from "./Tabs.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography";

interface TabsProps<Keys extends string> {
  tabs: {
    label: string;
    key: Keys;
  }[];
  activeTab: string;
  onTabChange: (key: Keys) => void;
}

// TODO animate tab transition
export function Tabs<Keys extends string>({ tabs, activeTab, onTabChange }: TabsProps<Keys>) {
  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`${styles.tab} ${tab.key === activeTab ? styles.active : ""}`}
          onClick={() => onTabChange(tab.key)}
        >
          <Typography>{tab.label}</Typography>
        </button>
      ))}
    </div>
  );
}
